import ringbackPath from './assets/ringback.aac';

const ringback = new Promise((resolve, reject) => {
  try {
    const tune = new Audio(ringbackPath);

    tune.stop = () => {
      try {
        tune.pause();
        tune.currentTime = 0;
      } catch (e) {
        console.error(e);
      }
    };

    tune.addEventListener(
      'canplaythrough',
      (event) => {
        tune.loop = true;
        tune.currentTime = 0;
        resolve(tune);
      },
      { once: true },
    );

    tune.addEventListener('error', (event) => {
      // NOTE: if for some reason we are unable to play sound then we mock the
      // interface so that everything will continue working as intended without
      // sound.
      resolve({
        play: () => null,
        stop: () => null,
      });
    });

    tune.load();
  } catch (e) {
    // NOTE: if for some reason we are unable to play sound then we mock the
    // interface so that everything will continue working as intended without
    // sound.
    resolve({
      play: () => null,
      stop: () => null,
    });
  }
});

export default ringback;
